// extracted by mini-css-extract-plugin
export default {"container":"U5nlv","mainCategory":"BK_fn","subcategories":"ea4XJ","categories":"_ORlw"};